import { Group, LoadingOverlay, Text } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const Upload = (props) => {
  const {
    labelIdlePre,
    labelIdlePost,
    labelLoading,
    labelAccepted,
    labelRejected,
    ...rest
  } = props;

  const Loader = (
    <Text size="xs" span>
      {labelLoading}
    </Text>
  );

  const [loading, setLoading] = useState(false);

  return (
    <Dropzone onDrop={() => setLoading(false)} radius="md" {...rest}>
      <Group position="center">
        <Dropzone.Accept>
          <div>
            <Text size="xs" span>
              {labelAccepted}
            </Text>
          </div>
        </Dropzone.Accept>
        <Dropzone.Reject>
          <div>
            <Text size="xs" span>
              {labelRejected}
            </Text>
          </div>
        </Dropzone.Reject>
        <Dropzone.Idle>
          <div>
            <Text size="xs" span>
              {labelIdlePre}
            </Text>
            <Text size="xs" color="primary" span underline>
              {labelIdlePost}
            </Text>
          </div>
        </Dropzone.Idle>
      </Group>
      <LoadingOverlay
        loader={Loader}
        overlayOpacity={1}
        visible={loading}
        inset={2}
      />
    </Dropzone>
  );
};

Upload.propTypes = {
  labelIdlePre: PropTypes.string,
  labelIdlePost: PropTypes.string,
  labelLoading: PropTypes.string,
  labelAccepted: PropTypes.string,
  labelRejected: PropTypes.string,
};

Upload.defaultProps = {
  labelIdlePre: null,
  labelIdlePost: null,
  labelLoading: null,
  labelAccepted: null,
  labelRejected: null,
};

export default Upload;
